import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { AlertModal } from "components";
import {
  acceptInvitation,
  uninviteUser,
  fetchUserInfo,
  getAppInfo,
} from "apis";
import { withRedux, displayError, isLoading } from "helpers";

function AcceptInvitationForm(props) {
  const [showForm, toggleForm] = useState(true);
  const [appName, setAppName] = useState(null);
  const [applicationId, setAppId] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const userInvitationToken = new URLSearchParams(window.location.search).get(
    "invitationToken"
  );

  if (userInvitationToken && appName === null) {
    isLoading(true);
  } else {
    isLoading(false);
  }

  useEffect(() => {
    if (userInvitationToken) getUserAndAppInfo();
  }, []);

  const getUserAndAppInfo = async () => {
    const userInfo = await fetchUserInfo(userInvitationToken);
    const { email, appId } = userInfo;
    const appInfo = await getAppInfo(appId);
    const { name } = appInfo;
    setAppId(appId);
    setUserEmail(email);
    setAppName(name);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      isLoading(true);
      const inviteRes = await acceptInvitation(userInvitationToken);
      props.actions.setUserApplicationsPermissions(inviteRes.userApplications);
      await props.actions.getApplicationsByUserId();
      isLoading(false);
      return props.history.push("/");
    } catch (e) {
      console.log(e);
      return displayError("Unable to accept invitation");
    }
  };

  const handleReject = async () => {
    try {
      await uninviteUser(userEmail, applicationId);
      return props.history.push("/");
    } catch (e) {
      console.log(e);
      return displayError("Unable to reject invitation");
    }
  };

  const renderButtons = [
    <Button
      key="acceptButton"
      variant="contained"
      color="primary"
      style={{
        height: "40px",
      }}
      onClick={handleSubmit}
    >
      Accept
    </Button>,
    <Button
      key="declineButton"
      variant="contained"
      color="secondary"
      style={{
        height: "40px",
      }}
      onClick={handleReject}
    >
      Decline
    </Button>,
  ];

  if (!userInvitationToken) return null;

  return (
    <AlertModal
      title="Accept Invitation"
      buttonText="Accept"
      buttonAction={handleSubmit}
      buttons={renderButtons}
      render={showForm}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <p>
          You have be invited to edit "{appName}"! Please accept or decline to
          continue.
        </p>
      </form>
    </AlertModal>
  );
}

export default withRedux(AcceptInvitationForm);
